import {
  Box,
  Button,
  FormControl,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useState } from "react";
import axios from "axios";
import BaseUrl from "../BaseUrl";
import { useEffect } from "react";
import Loader from "../Loader";
import TablePagination from "@mui/material/TablePagination";
import noDataImage from "../Images/Bankruptcy-cuate_blu.svg";
import { DatePicker } from "rsuite";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const headCells = [
  {
    id: 1,
    numeric: false,
    disablePadding: true,
    label: "Credits amount",
  },
  {
    id: 2,
    numeric: true,
    disablePadding: false,
    label: "Current balance",
  },
  {
    id: 3,
    numeric: true,
    disablePadding: false,
    label: "Info",
  },
  {
    id: 4,
    numeric: true,
    disablePadding: false,
    label: "Details",
  },
  {
    id: 5,
    numeric: true,
    disablePadding: false,
    label: "Date",
  },
];

const names = [
  "All transactions",
  "Sent email credit",
  "Verify email credit",
  "Contact credit",
];

const Transactions = () => {
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  const [personName, setPersonName] = useState("");
  const [transactionsData, setTransactionsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectFromDate, setFromDate] = useState(null);
  const [selectToDate, setSelectToDate] = useState(null);
  const [showToaser, setShowToaser] = useState(false);
  const [val, setVal] = useState(0);

  const handleToDate = (date) => {
    setSelectToDate(date);
  };

  const handleFromDate = (date) => {
    setFromDate(date);
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(value);
  };

  const handleFilter = () => {
    let start = new Date(selectFromDate);
    let end = new Date(selectToDate);
    let filtData = {
      startDate: new Date(start.setHours(0, 0, 1, 0)),
      endDate: new Date(end.setHours(23, 59, 59, 0)),
      type: personName,
    };
    axios
      .post(
        `${BaseUrl.baseurl}/email-marketing/user/get-transaction-by-custom/${
          userDetails && userDetails.details._id
        }`,
        filtData,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setTransactionsData(response.data.details);
        } else {
          setTransactionsData([]);
          setShowToaser(true);
          toast.warning(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        setIsLoading(false);
      })
      .catch((err) => console.log("Error"));
  };
  function resetFilter() {
    setFromDate(null);
    setSelectToDate(null);
    setPersonName("");
    getTransactions();
  }
  const disabledDate = (date) => {
    // Disable dates in the past before a given end date
    if (date.getTime() <= selectFromDate.getTime()) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    getTransactions();
    setVal((val) => val + 1);
  }, []);

  function getTransactions() {
    // setIsLoading(true)
    axios
      .get(
        `${BaseUrl.baseurl}/email-marketing/user/get-user-transaction/${
          userDetails && userDetails.details._id
        }`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setTransactionsData(response.data.details);
        } else {
          setTransactionsData([]);
          setShowToaser(true);
          toast.warning(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        setIsLoading(false);
      })
      .catch((err) => console.log("Error"));
  }

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    page > 0
      ? Math.max(0, (1 + page) * rowsPerPage - transactionsData.length)
      : 0;

  return (
    <div style={{ backgroundColor: "#fff" }}>
      <div style={{ padding: "0px 16px 0px 0px" }}>
        <Box sx={{ width: "100%", marginTop: 1 }}>
          <Paper
            sx={{
              width: "100%",
              borderRadius: "6px",
              border: "1px solid #DDD",
              boxShadow: "none",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                borderBottom: "1px solid #DDD",
                padding: "6px 16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Button
                disableRipple
                disableElevation
                sx={{
                  cursor: "default",
                  outline: "none !important",
                  borderBottom: "2px solid #1C485F",
                  borderRadius: 0,
                  color: "#1C485F",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
              >
                <Typography
                  style={{
                    color: "#1C485F",
                    fontSize: "15px",
                    fontWeight: 700,
                    fontFamily: "Source Sans 3",
                  }}
                  component="h2"
                >
                  All Transactions
                </Typography>
              </Button>
            </Box>
            <TableContainer>
              <Table
                sx={{ minWidth: 750 }}
                aria-labelledby="tableTitle"
                size={"medium"}
              >
                <TableHead>
                  <TableRow
                    sx={{ backgroundColor: "#FAFAFA", borderRadius: "4px" }}
                  >
                    {headCells.map((headCell) => (
                      <TableCell key={headCell.id} align="left">
                        <Typography
                          variant="subtitle1"
                          fontWeight="bold"
                          fontSize={"13px"}
                        >
                          {headCell.label}
                        </Typography>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                {isLoading ? (
                  // this body for display loading
                  <TableBody>
                    <TableRow>
                      <TableCell
                        colSpan={headCells.length}
                        align="center"
                        sx={{ borderBottom: "0px" }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "8px",
                            padding: "60px 0px",
                          }}
                        >
                          <Loader />
                        </Box>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : transactionsData.length > 0 ? (
                  // this body is for displaying data
                  <TableBody>
                    {transactionsData
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => (
                        <TableRow
                          key={row.id}
                          sx={{
                            backgroundColor:
                              index % 2 === 0 ? "#FFF" : "#FAFAFA",
                          }}
                        >
                          <TableCell align="left">
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "2px",
                              }}
                            >
                              <p
                                style={{
                                  marginTop: "0px",
                                  fontFamily: "Source Sans 3",
                                  fontSize: "15px",
                                  fontStyle: "normal",
                                  fontWeight: 700,
                                  color: "#868686",
                                }}
                              >
                                {row.CreditAmount}
                              </p>
                            </Box>
                          </TableCell>
                          <TableCell align="left" sx={{ color: "#868686" }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <span>{row.CurrentBalance}</span>
                            </Box>
                          </TableCell>
                          <TableCell align="left" sx={{ color: "#868686" }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <p
                                style={{
                                  color: "#868686",
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  fontFamily: "Source Sans 3",
                                  fontStyle: "normal",
                                }}
                              >
                                {row.Info}
                              </p>
                            </Box>
                          </TableCell>
                          <TableCell align="left" sx={{ color: "#868686" }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <p
                                style={{
                                  color: "#868686",
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  fontFamily: "Source Sans 3",
                                  fontStyle: "normal",
                                }}
                              >
                                {row.Details === "" ? "-" : row.Details}
                              </p>
                            </Box>
                          </TableCell>
                          <TableCell align="left" sx={{ color: "#868686" }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <p
                                style={{
                                  color: "#868686",
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  fontFamily: "Source Sans 3",
                                  fontStyle: "normal",
                                }}
                              >
                                {new Date(row.Date).toLocaleString("en-US", {
                                  month: "short",
                                  day: "numeric",
                                  year: "numeric",
                                  hour: "numeric",
                                  minute: "numeric",
                                  hour12: true,
                                })}
                              </p>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                ) : (
                  // this body for displaying empty data
                  <TableBody>
                    <TableRow>
                      <TableCell
                        colSpan={headCells.length}
                        align="center"
                        sx={{ borderBottom: "0px" }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <img
                            src={noDataImage}
                            alt="Nothing found"
                            style={{ height: "250px" }}
                          />
                          <p
                            style={{
                              fontFamily: "Source Sans 3",
                              fontSize: "20px",
                              fontStyle: "normal",
                              fontWeight: 700,
                              color: "#868686",
                            }}
                          >
                            No transaction details found
                          </p>
                        </Box>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
                {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: 53 * emptyRows,
                    }}
                  >
                    <TableCell colSpan={headCells.length} />
                  </TableRow>
                )}
              </Table>
            </TableContainer>
            {isLoading
              ? null
              : transactionsData.length > 0 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                    }}
                  >
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25]}
                      component="div"
                      count={transactionsData.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </div>
                )}
          </Paper>
        </Box>
        {showToaser && <ToastContainer />}
      </div>
    </div>
  );
};

export default Transactions;
